import AirBankLogo from 'assets/psd2/AIRBANK.svg?react';
import CreditasBankLogo from 'assets/psd2/CREDITAS.svg?react';
import CSASBankLogo from 'assets/psd2/CSAS.svg?react';
import CSOBBankLogo from 'assets/psd2/CSOB.svg?react';
import DefaultBankLogo from 'assets/psd2/gray_bank.svg?react';
import EQUABankLogo from 'assets/psd2/EQUA.svg?react';
import FIOBankLogo from 'assets/psd2/FIO.svg?react';
import JTBankLogo from 'assets/psd2/JTB.svg?react';
import KBBankLogo from 'assets/psd2/KB.svg?react';
import MBankLogo from 'assets/psd2/MBANK.svg?react';
import MonetaBankLogo from 'assets/psd2/MONETA.svg?react';
import RaiffeisenBankLogo from 'assets/psd2/RAIFFEISEN.svg?react';

const BANK_LOGOS: Record<
  string,
  React.FunctionComponent<React.SVGProps<SVGSVGElement>>
> = {
  KB: KBBankLogo,
  CSOB: CSOBBankLogo,
  CSAS: CSASBankLogo,
  CREDITAS: CreditasBankLogo,
  MONETA: MonetaBankLogo,
  AIRBANK: AirBankLogo,
  JTB: JTBankLogo,
  FIO: FIOBankLogo,
  RAIFFEISEN: RaiffeisenBankLogo,
  EQUA: EQUABankLogo,
  MBANK: MBankLogo,
};

export default BANK_LOGOS;

export const defaultBankLogo = DefaultBankLogo;
